import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { prescriptionQKeys } from "@hooks/queries/prescription/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Medication } from "@customTypes/prescription";


export const useUpdateMedication = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (medication: Partial<Medication>) => {
      return api.patch(`medication/${medication.id}`, {
        ...medication,
        medication_name: medication.name,
        prescription_id: medication.prescriptionId,
      });
    },
    onSuccess: (_, variables) => {
      // console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "update-medication-success",
      });
      queryClient.invalidateQueries(
        prescriptionQKeys.medication(variables.prescriptionId as string)
      );
    },

    onError: (res: any) => {
      console.error("[From Update Medication]", res);

      handleErrors(res, "mutation");
    },
  });
};
